import React from 'react'
import CustomCursor from '../../Global/Cursor'
import Preloader from '../../Global/Preloader'
import Header from '../../Global/Header1'
import PageHeader from '../../Global/PageHService'
import Services from '../Menservices/Services'
import Cta from '../../Global/Cta'
import Footer from '../../Global/Footer1'
import GoToTop from '../../Global/GoToTop'

const Main = () => {
    return (
        <>
            <CustomCursor />
            <Preloader />
            <Header />
            <PageHeader Title="Services" Subtitle="Services" />
            <Services />
            <Cta />
            <Footer />
            <GoToTop />
        </>
    )
}

export default Main
